import type { FC } from "react";

import {
  ClientTableToolbar,
  ToolbarFilterPill
} from "../../components/table/ClientTableToolbar";
import { CASES_FILTER_LABEL, type CasesFilter } from "../../lib/caseStatus";
import { SORT_OPTIONS, isSameSort, type CasesSort } from "./casesModel";

type Props = {
  title: string;
  filter: CasesFilter;
  onFilterChange: (filter: CasesFilter) => void;
  sort: CasesSort;
  onSortChange: (sort: CasesSort) => void;
  onNewCase: () => void;
};

const FILTERS: Exclude<CasesFilter, "all">[] = [
  "in_progress",
  "pending",
  "completed"
];

/** The Cases header: title, then sort, status filter and New Case. */
export const CasesToolbar: FC<Props> = ({
  title,
  filter,
  onFilterChange,
  sort,
  onSortChange,
  onNewCase
}) => {
  const sortKey =
    SORT_OPTIONS.find((o) => isSameSort(o.sort, sort))?.key ?? "default";

  return (
    <ClientTableToolbar
      title={title}
      sort={{
        ariaLabel: "Sort cases",
        options: SORT_OPTIONS.map((o) => ({ value: o.key, label: o.label })),
        value: sortKey,
        onChange: (key) => {
          const next = SORT_OPTIONS.find((o) => o.key === key);
          if (next) onSortChange(next.sort);
        }
      }}
      filters={
        <ToolbarFilterPill<CasesFilter>
          appearance="ghost"
          icon="FeatherFilter"
          label="Status"
          ariaLabel="Filter cases by status"
          value={filter}
          options={FILTERS.map((f) => ({
            value: f,
            label: CASES_FILTER_LABEL[f]
          }))}
          allOption={{ value: "all", label: CASES_FILTER_LABEL.all }}
          onChange={onFilterChange}
        />
      }
      primaryAction={{
        label: "New Case",
        ariaLabel: "New Case",
        onClick: onNewCase
      }}
    />
  );
};
